export type CookieCategories = {
    advertising?: boolean;
    analytics?: boolean;
    functional?: boolean;
    marketing?: boolean;
    necessary?: boolean;
    performance?: boolean;
};

export type CookieServices = Record<string, boolean | undefined>;

export type ScannedCookie = {
    category?: keyof CookieCategories;
    description?: string;
    domain?: string;
    expiration?: string;
    id?: string;
    name?: string;
    type?: 'cookie' | 'local_storage' | 'session_storage';
};

export type CookieScan = {
    cookies: ScannedCookie[];
};

export type CookieBannerState = {
    categories?: CookieCategories;
    consented?: boolean;
    cookieScan?: CookieScan;
    initialized?: boolean;
    ready?: boolean;
    services?: CookieServices;
};

export type CookieBannerStore = {
    cookieBanner?: CookieBannerState;
};

export type CookieFirstScanResponse = {
    cookies: {
        cat?: string;
        desc?: string;
        domain?: string;
        expiration_time?: string;
        id?: string;
        name?: string;
        type?: string;
    }[];
};

export type CookieFirstWindowEvent = {
    detail?: CookieCategories | CookieServices;
};

export type CookieFirstWindow = Window & {
    CookieFirst?: {
        fetchLatestScan?: () => Promise<CookieFirstScanResponse>;
    };
};

export function isCookieCategories(input: any): input is CookieCategories {
    const isObject = typeof input === 'object' && input !== null;

    if (!isObject) {
        return false;
    }

    const expectedProperties = ['advertising', 'analytics', 'functional', 'marketing', 'necessary', 'performance'];

    return expectedProperties.some((prop) => prop in input && typeof input[prop] === 'boolean');
}

export function isCookieServices(input: any): input is CookieServices {
    const isObject = typeof input === 'object' && input !== null;

    if (!isObject) {
        return false;
    }

    return Object.values(input).every((value) => value === true || value === false || value === undefined);
}
